import React, { useEffect, useRef } from 'react'
import { getPortfolioItem } from "../../api/portfolio/PortfolioData";
import BgImage from "../../components/header/BgImage";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import ButtonDefault from "../../components/button/button-default/ButtonDefault";
import BoxImageVertical from "../../components/box-image-vertical/BoxImageVertical";
import DsnGrid from "../../components/DsnGrid";
import { Container } from "react-bootstrap";
import FadeUpTrigger from "../../animation/FadeUpTrigger";
import TextTrigger from "../../animation/TextTrigger";
//--> Component
import HeaderHalf from "../../components/header/HeaderHalf";
import TitleCover from "../../components/heading/title-cover/TitleCover";
import NextProject from "../../components/next/NextProject";
import BoxGallery from "../../components/box-gallery/BoxGallery";
import ParallaxImage from "../../components/parallax-image/ParallaxImage";
import { Helmet } from 'react-helmet-async';
import ButtonPopup from "../../components/button/button-popup/ButtonPopup";


const ExperienceRBC = ({ data }) => {

  const nextData = getPortfolioItem(2);
  return (
    <React.Fragment>
      <Helmet>
        <title>Devlift - {data.title} </title>
        <link rel='canonical' href='/portolio/rbc' />
        <meta
          name="description"
          content={data.description}
        />
      </Helmet>
      {/*Start Header Half*/}
      <HeaderHalf heroContent={data}
        textButton="View Website"
        href="#"
        overlay={data.overlay}>

      </HeaderHalf>
      {/*End Header Half*/}

      {/*Start Info Project*/}
      <Container className="section-margin">
        <TitleCover>The Ask</TitleCover>
        <TextTrigger duration={0.8} stagger={0.1}>
          {(ref) => <h2 className="title-section" ref={ref}>The Ask</h2>}
        </TextTrigger>
        <FadeUpTrigger>
          <p className="mt-20">
            RBC opened eXperience RBC, a first-of-its-kind concept space that provides interactive technology to help Canadians explore their financial questions in an easy-to-use manner, enhancing meaningful conversations. Devlift was engaged to help bring to life the state-of-the-art surface screen technology that would help advise and educate small businesses - empowering them to start on the path to bringing their goals and passions to life.
          </p>
        </FadeUpTrigger>
      </Container>
      {/*End Info Project*/}
      <div className="p-relative section-margin v-dark-head text-center">
        <ParallaxImage src="/assets/img/project/rbc/header3.jpg" heightMobile="50vh" heightTable="100vh" overlay={0} />
        <FadeUpTrigger tag={Container} className="v-middle z-index-1">
          {/* <h2>The Showroom</h2>
                    <p className="m-w570 mt-20 dsn-auto">
                        When the Escalators Died in Stockholm’s Subway, Reebok Was
                        There to Give People a Lift.Literally
                    </p> */}
          <ButtonPopup className="mt-20" href="/assets/videos/rbc.mp4" />
        </FadeUpTrigger>
      </div>

      {/*Start Box Info With Image*/}
      <BoxImageVertical
        src="/assets/img/project/rbc/header2.jpg"
        className="section-margin"
      >
        <FadeUpTrigger>
          {(ref) => (
            <DsnGrid col={1} rowGap={30} rowGapTablet={20}>
              <TitleCover>The Solution</TitleCover>
              <h2 className="title-section border-line-left" ref={ref}>
                The Solution
              </h2>
              <p ref={ref}>
                With the help of a team of caring advisors and expert partners, Devlift brought to life the interactive, cross-platform framework thereby providing a unique experience in a retail banking environment.
              </p>
              <p ref={ref}>
                Using Electron and Angular to build the educational tools that would be accessible on various surface screen technologies, Devlift was able to quickly build and deliver a high-performance and simple to use experience. These technologies helped to bring the interfaces to life by incorporating animations as a functional element that enhanced the user experience. The animations were an important tool for successful interaction and provided visual feedback for the user’s choices.
              </p>
              {/* <div className="button-box" ref={ref}>
                <ButtonDefault text="launch" icon={faAngleRight} href="#0" />
              </div> */}
            </DsnGrid>
          )}
        </FadeUpTrigger>
      </BoxImageVertical>

      <BoxGallery
        className="section-margin"
        col={3}
        colMobile={1}
        colGap={0}
        rowGap={0}
        images={[
          {
            src: '/assets/img/project/rbc/screen1.gif',
            caption: "",
          },
          {
            src: '/assets/img/project/rbc/screen2.gif',
            caption: "",
          },
          {
            src: '/assets/img/project/rbc/screen3.gif',
            caption: "",
          },
        ]}
      />


      <NextProject heroContent={nextData} overlay={nextData.overlay} />


    </React.Fragment>
  );
}


export default ExperienceRBC;